<template>
  <div class="bg-primary w-100">
    <div class="flex justify-center">
      <div class="mw9-ns w-100 flex flex-wrap justify-between items-center ph3 pb5">
        <div class="flex di-ns justify-between w-100 w-auto-ns">
          <div class="mh2 mv1 mw-100 h-100 w4 flex justify-start">
            <img class="h-100 w-100 pointer db-ns dn" src="../../assets/logo-white.svg"
                alt="BeatHey Logo">
            <div class="dn-ns pv1 w-35">
              <img class="ph3 w-100 h-100 pointer" src="../../assets/isologo-white.svg" alt="BeatHey Logo">
            </div>
          </div>
          <div class="flex justify-center">
            <a href="https://www.facebook.com/BeatHeyOK/" class="pa2 textColor" target="_blank"><font-awesome-icon :icon="['fab', 'facebook']" size="2x"/></a>
            <a href="https://www.instagram.com/beatheyok/" class="pa2 textColor" target="_blank"><font-awesome-icon :icon="['fab', 'instagram']" size="2x"/></a>
          </div>
        </div>
        <div class="flex justify-between w-50-l w-60-m w-100">
          <div class="textColor flex flex-column justify-start">
            <p class="b ph3">{{ $t("footer.company") }}</p>
            <router-link :to="{ name: 'general-terms-' + language }" target="_blank"
                          class="no-underline pv1 ph3 f6 pointer gray">{{ $t("footer.termsOfUse") }}
            </router-link>
            <router-link :to="{ name: 'intellectual-prop-' + language }" target="_blank"
                          class="no-underline pv1 ph3 f6 pointer gray">{{ $t("footer.intellectuallyProp") }}
            </router-link>
            <router-link :to="{ name: 'privacy-policy-' + language }" target="_blank"
                          class="no-underline pv1 ph3 f6 pointer gray">{{ $t("footer.privacyPolicy") }}
            </router-link>
            <router-link :to="{ name: 'help' }"
                          class="no-underline pv1 ph3 f6 pointer gray">{{ $t("footer.help") }}
            </router-link>
            <router-link :to="{ name: 'help' }"
                          class="no-underline pv1 ph3 f6 pointer gray">{{ $t("footer.contact") }}
            </router-link>
          </div>
          <div class="flex flex-column textColor justify-start h-100">
            <p class="b ph3">{{ $t("footer.language.title") }}</p>
            <button @click="setLanguage('es')" :disabled="isCurrentLanguage('es')" :class="{ 'pointer enabledButton': !isCurrentLanguage('es') }"
              class="bn bg-primary ph3 f6 pv1 mv0 gray">{{ $t("footer.language.spanish") }}</button>
            <button @click="setLanguage('en')" :disabled="isCurrentLanguage('en')" :class="{ 'pointer enabledButton': !isCurrentLanguage('en') }"
              class="bn bg-primary ph3 f6 pv1 mv0 gray">{{ $t("footer.language.english") }}</button>
            <button @click="setLanguage('pt')" :disabled="isCurrentLanguage('pt')" :class="{ 'pointer enabledButton': !isCurrentLanguage('pt') }"
              class="bn bg-primary ph3 f6 pv1 mv0 gray">{{ $t("footer.language.portuguese") }}</button>
          </div>
          <a href="http://qr.afip.gob.ar/?qr=z2lwtWwTrNS5X9tbTtwmtw,," class="mv3" target="_blank">
            <img class="h3" src="/static/assets/DATAWEB.jpg" :alt="`Dataweb`">
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters} from 'vuex'
export default {
  name: 'home-footer',
  methods: {
    ...mapActions('translator', [
      'setLanguage'
    ])
  },
  computed: {
    ...mapGetters('translator', [
      'language',
      'isCurrentLanguage'
    ])
  }

}
</script>

<style scoped lang="scss">
  @import '~@/variables.scss';

  a:hover{
    color: $background-color;
  }
  .enabledButton:hover{
    color: $background-color;
  }
</style>



// WEBPACK FOOTER //
// src/components/home/HomeFooter.vue